<template>
	<Skeleton :paragraph="{ rows: 7 }" :title="false" :loading="isLoading">
		<VerticalLayout>
			<LabeledSwitch
				v-model="showCompletedRows"
				:rightLabel="$t('settings.statsAggregation.showCompletedRows')"
			/>
			<div class="scrollable-x">
				<Table
					:columns="columns"
					:data-source="displayedItems"
					:pagination="false"
					size="small"
				>
					<template #bodyCell="{ column, record }">
						<template v-if="column.dataIndex === 'first_datetime'">
							<DateTimeDisplay :date="record.first_datetime" hideUtc />
						</template>
						<template v-else-if="column.dataIndex === 'last_datetime'">
							<DateTimeDisplay :date="record.last_datetime" hideUtc />
						</template>
						<template v-else-if="column.dataIndex === 'last_aggregated_datetime'">
							<DateTimeDisplay :date="record.last_aggregated_datetime" hideUtc />
						</template>
						<template v-else-if="column.dataIndex === 'percent'">
							{{ record.percent ? record.percent.toFixed(2) : '0.00' }}%
						</template>
					</template>
					<template #emptyText>
						{{ $t('settings.statsAggregation.noData') }}
					</template>
				</Table>
			</div>
		</VerticalLayout>
	</Skeleton>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { Skeleton, Table } from 'ant-design-vue';

import Api from '@/api/Api';
import Consts from '@/api/Consts';

import DateTimeDisplay from '@/components/common/DateTimeDisplay';
import LabeledSwitch from '@/components/common/LabeledSwitch.vue';
import VerticalLayout from '@/components/common/VerticalLayout';

const COMPLETED_PERCENT_THRESHOLD = 99;

export default {
	components: {
		Skeleton, Table, DateTimeDisplay, LabeledSwitch, VerticalLayout,
	},
	props: {
		loading: {
			type: Boolean,
			default: false,
		},
	},
	setup() {
		const isLoading = ref(false);
		const items = ref([]);
		const showCompletedRows = ref(false);
		const columns = Consts.statsAggregationTableColumnsComp;
		const displayedItems = computed(() => {
			if (showCompletedRows.value) {
				return items.value;
			}
			return items.value.filter(item => (item.percent ?? 0) < COMPLETED_PERCENT_THRESHOLD);
		});
		const fetchData = () => {
			isLoading.value = true;
			Api.casterStatsAggregationProgressGet(response => {
				if (response.status === 'ok') {
					items.value = response.items || [];
				}
				isLoading.value = false;
			});
		};
		onMounted(fetchData);
		return {
			isLoading,
			items,
			showCompletedRows,
			displayedItems,
			columns,
		};
	},
}
</script>
